// types
import * as React from 'react';
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { getBaseUrl } from '../../envUtils';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// initial state
const initialState = {
    openItem: [''],
    openComponent: 'buttons',
    drawerOpen: true,
    componentDrawerOpen: true,
    alertOpen: false
};

// ==============================|| SLICE - MENU ||============================== //

window.captureScreen = () => {
    var sceneResolution = 1.0;

    var scene = viewer.scene;

    if (!scene) {
        console.error('No scene');
    }

    var prepareScreenCapture = function () {
        viewer.resolutionScale = sceneResolution;

        scene.preRender.removeEventListener(prepareScreenCapture);

        setTimeout(function () {
            scene.postRender.addEventListener(snapCamera);
        }, 100);
    };

    function renderImage(uri, name) {
        var img = document.createElement('img');
        img.style.height = '40px';
        img.src = uri;
        document.querySelector('twinworld-app').shadowRoot.querySelector('#snapshots').append(img);
    }

    function createTwin(file) {
        /*if (window.taskToUse) {
            const dataValue = JSON.parse(window.taskToUse);
            if (dataValue.building_id && !dataValue.buildingid) {
                dataValue.buildingid = dataValue.building_id;
            }
            window
                .saveScene(
                    {
                        buildingid: dataValue.buildingid,
                        siteid: dataValue.siteid,
                        scene_id: dataValue.scene_id,
                        assetName: window.currentAssetName,
                        boundingBox: window.destBoundingBox,
                        latitude: document.querySelector('twinworld-app').shadowRoot.getElementById(`${window.currentAssetName}_lat`)
                            ? (document.querySelector('twinworld-app').shadowRoot.getElementById(`${window.currentAssetName}_lat`).value *
                                  180) /
                              Cesium.Math.PI
                            : (window.destCenter.latitude * 180) / Cesium.Math.PI,
                        height: window.destCenter.height,
                        longitude: document.querySelector('twinworld-app').shadowRoot.getElementById(`${window.currentAssetName}_lon`)
                            ? (document.querySelector('twinworld-app').shadowRoot.getElementById(`${window.currentAssetName}_lon`).value *
                                  180) /
                              Cesium.Math.PI
                            : (window.destCenter.longitude * 180) / Cesium.Math.PI,
                        pois: JSON.stringify(window.allPickedAssets),
                        newSceneId: window.newSceneId,
                        rotation: JSON.stringify(window.drone.orientation._value),
                        scale: '' + window.drone.model.scale._value,
                        airQuality: JSON.stringify(window.airQuality),
                        cameraPosition: JSON.stringify({
                            destination: viewer.scene.camera.position,
                            orientation: {
                                heading: viewer.camera.heading,
                                pitch: viewer.camera.pitch,
                                roll: viewer.camera.roll
                            }
                        })
                    },
                    true
                )
                .then((sceneResponse) => {
                    const sceneId = sceneResponse.newSceneId;
                    const siteId = sceneResponse.newSiteId;
                    console.log('Scene Id ', sceneId);
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.loaderbg').style.display = 'block';
                    const formData = new FormData();
                    formData.append('permission', 'draft');
                    formData.append('upload_files', file);
                    formData.append('name', window.currentAssetName.split('/').splice(-1, 1)[0].replace('Building Id : ', ''));
                    formData.append('descriptions', '');
                    formData.append('description', '');
                    formData.append('world_id', sceneId);
                    formData.append('tags', []);
                    formData.append('folders', []);
                    window.worldSceneId = sceneId;
                    axios
                        .post(`${getBaseUrl()}/api/v1/twin/`, formData, {
                            withCredentials: true
                        })
                        .then((res) => {
                            const resData = res.data;
                            console.log(resData);
                            fetch(`${getBaseUrl()}/twinworld/updateSceneImage`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                credentials: 'include',
                                body: JSON.stringify({
                                    sceneId: window.newSceneId,
                                    worldSceneId: window.worldSceneId,
                                    sceneImage: resData.images[0].s3_url
                                })
                            })
                                .then((res) => res.json())
                                .then((sceneResponse) => {
                                    document.querySelector('twinworld-app').shadowRoot.querySelector('.loaderbg').style.display = 'none';
                                    resolve(sceneResponse);
                                });
                        })
                        .catch((err) => {
                            document.querySelector('twinworld-app').shadowRoot.querySelector('.loaderbg').style.display = 'none';
                            console.error(err);
                        });
                });
        } else */
        if (window.usdaAgentSceneData && window.usdaAgentSceneData.newScene) {
            const sceneId = window.usdaAgentSceneData.newSceneId;
            const formData = new FormData();
            formData.append('permission', 'draft');
            formData.append('upload_files', file);
            formData.append('name', window.usdaAgentSceneData.name.replace('Building Id : ', ''));
            formData.append('descriptions', window.usdaAgentSceneData.description.substring(0, 103).replace(',', ''));
            formData.append('description', window.usdaAgentSceneData.description.substring(0, 103).replace(',', ''));
            formData.append('world_id', sceneId);
            formData.append('tags', []);
            formData.append('folders', []);
            window.worldSceneId = sceneId;
            axios
                .post(`${getBaseUrl()}/api/v1/twin/`, formData, {
                    withCredentials: true
                })
                .then((res) => {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.loaderbg').style.display = 'none';
                    const resData = res.data;
                    console.log(resData);
                    fetch(`${getBaseUrl()}/twinworld/updateSceneImage`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        credentials: 'include',
                        body: JSON.stringify({
                            sceneId: window.usdaAgentSceneData.id,
                            worldSceneId: sceneId,
                            sceneImage: resData.images[0].s3_url
                        })
                    })
                        .then((res) => res.json())
                        .then((sceneResponse) => {
                            document.querySelector('twinworld-app').shadowRoot.querySelector('.loaderbg').style.display = 'none';
                            //resolve(sceneResponse);
                        });
                })
                .catch((err) => {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.loaderbg').style.display = 'none';
                    console.error(err);
                });
        }
    }

    function drawBoundary(canvas) {
        const ctx = canvas.getContext('2d');
        ctx.strokeStyle = 'orange';
        ctx.beginPath();
        ctx.roundRect(0, 0, 150, 100, [40]);
        ctx.stroke();
    }

    var snapCamera = function () {
        scene.postRender.removeEventListener(snapCamera);

        var canvas = scene.canvas;

        // drawBoundary(canvas);

        canvas.toBlob(
            function (blob) {
                var url = URL.createObjectURL(blob);
                const file = new File([blob], 'image');
                //renderImage(url, 'snapshot-' + sceneResolution.toString() + 'x.png');
                createTwin(file);
                viewer.resolutionScale = 1.0;
                // window.showAlert('Twin created');
            },
            'image/jpeg',
            0.5
        );
    };

    const sceneNaming = () => {
        const dialog = document.createElement('dialog');
        const label = document.createElement('label');
        label.textContent = 'Enter Scene Name:';
        label.setAttribute('for', 'sceneName');

        const input = document.createElement('input');
        input.type = 'text';
        input.id = 'sceneName';
        input.style.padding = '8px';
        input.style.marginBottom = '16px';

        const okButton = document.createElement('button');
        okButton.id = 'okBtn';
        okButton.textContent = 'OK';
        okButton.style.color = '#ff6101';
        okButton.style.padding = '8px 16px';
        okButton.style.marginRight = '10px';

        const cancelButton = document.createElement('button');
        cancelButton.id = 'cancelBtn';
        cancelButton.textContent = 'Cancel';
        cancelButton.style.padding = '8px 16px';

        dialog.appendChild(label);
        dialog.appendChild(document.createElement('br'));
        dialog.appendChild(input);
        dialog.appendChild(document.createElement('br'));
        dialog.appendChild(okButton);
        dialog.appendChild(cancelButton);

        document.body.appendChild(dialog);
        dialog.showModal();

        // Logic for OK and Cancel
        return new Promise((resolve, reject) => {
            function sendSceneName(value) {
                resolve(value);
                dialog.close();
                dialog.remove();
            }

            okButton.addEventListener('click', () => {
                sendSceneName(input.value.trim());
            });

            cancelButton.addEventListener('click', () => {
                sendSceneName('NewScene');
            });
        });
    };

    sceneNaming().then((sceneName) => {
        document.querySelector('twinworld-app').shadowRoot.querySelector('.loaderbg').style.display = 'block';

        // ── Build scene data from current Cesium state ────────────────────
        const latDeg = window.destCenter?.latitude
            ? (window.destCenter.latitude  * 180) / Math.PI
            : window.assetDropPosition?.lat || 0;
        const lonDeg = window.destCenter?.longitude
            ? (window.destCenter.longitude * 180) / Math.PI
            : window.assetDropPosition?.lon || 0;

        window.saveScene({
            name:            sceneName,
            description:     `Scene at (${latDeg.toFixed(6)}, ${lonDeg.toFixed(6)})`,
            building_id:     window.selectedBuildingId || '',
            latitude:        latDeg,
            longitude:       lonDeg,
            height:          window.destCenter?.height || window.assetDropPosition?.height || 0,
            boundingBox:     window.destBoundingBox,
            rotation:        window.drone?.orientation?._value
                                 ? JSON.stringify(window.drone.orientation._value) : '0',
            angularRotation: window.drone?.rotationAngle != null
                                 ? String(window.drone.rotationAngle) : '0',
            scale:           window.drone?.model?.scale?._value != null
                                 ? String(window.drone.model.scale._value) : '1.0',
            building_glb:    window.assetBeingDropped || window.currentAssetName || '',
            twin_provider:   'local'
        }).then((sceneData) => {
            const sceneId = sceneData.id;
            window.newSceneId = sceneId;
            window.sceneId    = sceneId;   // ← makes arche-engine prompts work immediately after save
            console.log('Scene created ::', sceneData);

            // Set shape expected by createTwin
            window.usdaAgentSceneData = {
                ...sceneData,
                id:          sceneId,
                newScene:    true,
                newSceneId:  sceneId,
                name:        sceneName,
                description: sceneData.description || ''
            };

            // Trigger screenshot which feeds into createTwin → POST /api/v1/twin/ → updateSceneImage
            scene.preRender.addEventListener(prepareScreenCapture);

            viewer.camera.flyTo({
                destination: viewer.scene.camera.position,
                orientation: {
                    heading: viewer.camera.heading - 0.001,
                    pitch:   viewer.camera.pitch,
                    roll:    viewer.camera.roll
                }
            });

            if (window.locationIntelSearchData) {
                window.locationIntelSearchData.sceneId = sceneId;
                fetch(`${getBaseUrl()}/twinworld/getLocationIntel`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(window.locationIntelSearchData)
                })
                    .then((res) => res.json())
                    .then((resJson) => {
                        console.log('Location intel data : resJson', resJson);
                    });
            }
        }).catch((err) => {
            console.error('❌ Failed to create scene:', err);
            document.querySelector('twinworld-app').shadowRoot.querySelector('.loaderbg').style.display = 'none';
        });
    });
};





const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem(state, action) {
            document
                .querySelector('twinworld-app')
                .shadowRoot.querySelectorAll('.left-toolbar-container')
                .forEach((leftTool) => {
                    leftTool.style.width = 0;
                    leftTool.style.display = 'none';
                    leftTool.style.visibility = 'hidden';
                });
            document
                .querySelector('twinworld-app')
                .shadowRoot.querySelectorAll('.topup-toolbar-container')
                .forEach((topupTool) => {
                    topupTool.style.height = 0;
                    topupTool.style.visibility = 'hidden';
                });

            document.querySelector('twinworld-app').shadowRoot.querySelector('.robot-scanner-container').style.width = 'unset';
            document
                .querySelector('twinworld-app')
                .shadowRoot.querySelector('.robot-scanner-container')
                .setAttribute(
                    'style',
                    document
                        .querySelector('twinworld-app')
                        .shadowRoot.querySelector('.robot-scanner-container')
                        .getAttribute('style')
                        .replace(' width: 350px !important;', '')
                );
            if (state.openItem[0] !== 'modelOnMap') {
                window.siteSelectionActive = false;
            }

            state.openItem = action.payload.openItem;
            console.log('Open item ::', state.openItem);
            if (window.activeOption === state.openItem[0]) {
                window.activeOption = '';
            } else {
                window.activeOption = state.openItem[0];
            }
            if (state.openItem[0] === 'collaborate') {
                window.location.assign('https://twinup.dev.cityzenith.com/');
            } else if (state.openItem[0] === 'world') {
                window.location.assign('/');
            } else if (state.openItem[0] === 'building') {
                window.location.assign('/');
            } else if (state.openItem[0] === 'screenshot') {
                captureScreen();
            } else if (state.openItem[0] === 'massing') {
                if (window.activeOption === 'massing') {
                    window.massingActive = true;
                } else {
                    window.massingActive = false;
                }
            } else if (state.openItem[0] === 'cost') {
                if (window.activeOption === 'cost') {
                    showCost();
                } else {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#robot-scanner').style.display === 'none';
                }
            } else if (state.openItem[0] === 'zoning') {
                if (window.activeOption === 'zoning') {
                    showZoning();
                } else {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#robot-scanner').style.display === 'none';
                }
            } else if (state.openItem[0] === 'regulation') {
                if (window.activeOption === 'regulation') {
                    showRegulation();
                } else {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#robot-scanner').style.display === 'none';
                }
            } else if (state.openItem[0] === 'carbon') {
                if (window.activeOption === 'carbon' && window.allPickedAssets) {
                    showCarbon();
                } else {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#robot-scanner').style.display === 'none';
                }
            } else if (state.openItem[0] === 'models') {
                document.querySelector('twinworld-app').shadowRoot.querySelector('#navChanger').click();
            } else if (state.openItem[0] === 'search') {
                if (window.applyGlobeSpinEvent) {
                    window.applyGlobeSpinEvent();
                }
                viewer.clock.onTick.removeEventListener(window.applyGlobeSpin);
                if (
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.cesium-viewer-geocoderContainer').style.display ===
                    'block'
                ) {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.cesium-viewer-geocoderContainer').style.display =
                        'block';
                } else {
                    document
                        .querySelector('twinworld-app')
                        .shadowRoot.querySelector('.cesium-viewer-geocoderContainer .cesium-geocoder-input').style.width = '250px';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.cesium-viewer-geocoderContainer').style.display =
                        'block';
                }
                /*
                setTimeout(() => {
                    document
                        .querySelector('twinworld-app')
                        .shadowRoot.querySelector('.cesium-viewer-geocoderContainer .cesium-geocoder-input').style.width = '0';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.cesium-viewer-geocoderContainer').style.display =
                        'none';
                }, 12000);
                */
            } else if (state.openItem[0] === 'maps') {
                document.querySelector('twinworld-app').shadowRoot.querySelector('#legendChanger').click();
            } else if (state.openItem[0] === 'marque') {
                document.querySelector('twinworld-app').shadowRoot.querySelector('#marqueChanger').click();
            } else if (state.openItem[0] === 'tapeMeasure') {
                window.changeOriginOnClickGlobal = true;
                document.querySelector('twinworld-app').shadowRoot.querySelector('#Measurement').click();
            } else if (state.openItem[0] === 'sun') {
                viewer.scene.light.intensity = (viewer.scene.light.intensity + 20) % 100;
            } else if (state.openItem[0] === 'robot') {
                window.changeOriginOnClickGlobal = false;
                window.startRobotScanner(200, true);
            } else if (state.openItem[0] === 'contextData') {
                /*if (!window.scanState || window.scanState === 'complete') {
                    window.changeOriginOnClickGlobal = false;
                    window.startRobotScanner(200, true);
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#robot-scanner').style.display = 'block';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#robot-scanner').style.visibility = 'visible';
                }*/

                const searchSubmenu = document.querySelector('twinworld-app')?.shadowRoot?.querySelector('#search-submenu');
                const chatInput = document.querySelector('.chatAgent input');
                // SearchOption removed — chat is handled by the parent app.
                // Keep #search-submenu permanently hidden; do not toggle it.
                if (searchSubmenu) searchSubmenu.style.display = 'none';

                const geocoderContainer = document.querySelector('twinworld-app')?.shadowRoot?.querySelector('.cesium-viewer-geocoderContainer');
                if (geocoderContainer && geocoderContainer.style.display === 'block') {
                    geocoderContainer.style.display = 'block';
                }
            } else if (state.openItem[0] === 'modelOnMap') {
                if (
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.cesium-viewer-geocoderContainer').style.display ===
                    ''
                ) {
                    if (window.applyGlobeSpinEvent) {
                        window.applyGlobeSpinEvent();
                    }
                    viewer.clock.onTick.removeEventListener(window.applyGlobeSpin);
                }
                if (
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.cesium-viewer-geocoderContainer').style.display ===
                        '' ||
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.cesium-viewer-geocoderContainer').style.display ===
                        'none'
                ) {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.cesium-viewer-geocoderContainer').style.display =
                        'block';
                } else {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('.cesium-viewer-geocoderContainer').style.display =
                        'block';
                }

                window.siteSelectionActive = true;
                window.setupAreaOfInterest();
                /*
                if (
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#legend-container').style.display === '' ||
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#legend-container').style.display === 'none'
                ) {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#legend-container').style.display = 'block';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#legend-container').style.visibility = 'visible';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#legend-container').style.width = '304px';
                } else {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#legend-container').style.visibility = 'hidden';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#legend-container').style.display = 'none';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#legend-container').style.width = '0px';
                }*/
            } else if (window.activeOption === 'move') {
                if (
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#transform-submenu').style.display === '' ||
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#transform-submenu').style.display === 'none'
                ) {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#transform-submenu').style.display = 'block';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#transform-submenu').style.visibility = 'visible';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#transform-submenu').style.width = '304px';
                } else {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#transform-submenu').style.visibility = 'hidden';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#transform-submenu').style.display = 'none';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#transform-submenu').style.width = '0px';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#move-container').style.display = 'none';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#rotate-container').style.display = 'none';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#scale-container').style.display = 'none';
                }
            } else if (state.openItem[0] === 'scale') {
                if (
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#scale-container').style.display === '' ||
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#scale-container').style.display === 'none'
                ) {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#scale-container').style.display = 'block';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#scale-container').style.visibility = 'visible';
                } else {
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#scale-container').style.visibility = 'hidden';
                    document.querySelector('twinworld-app').shadowRoot.querySelector('#scale-container').style.display = 'none';
                }
            } else if (state.openItem[0] === 'voice') {
                document.querySelector('twinworld-app').shadowRoot.querySelector('#sayArchie').click();
            } else if (state.openItem[0] === 'gaussianSplats') {
                // Toggle the Gaussian Splat panel — mounted by Scenes.js on load
                const sr = document.querySelector('twinworld-app')?.shadowRoot;
                if (sr) {
                    const panel = sr.querySelector('#gaussian-splat-panel');
                    if (panel) {
                        panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
                    }
                }
            }
            if (window.activeOption === '') {
                document.querySelector('twinworld-app').shadowRoot.querySelector('.cesium-viewer-geocoderContainer').style.display =
                    'block';
            }
        },

        activeComponent(state, action) {
            state.openComponent = action.payload.openComponent;
        },

        openDrawer(state, action) {
            state.drawerOpen = action.payload.drawerOpen;
        },

        openComponentDrawer(state, action) {
            state.componentDrawerOpen = action.payload.componentDrawerOpen;
        }
    }
});

export default menu.reducer;

export const { activeItem, activeComponent, openDrawer, openComponentDrawer } = menu.actions;
